import { Table } from 'antd';
import { IDocRowMycent } from '../type';
import api from '@modules/Edo/services/api';
import { useState } from 'react';
import dayjs from 'dayjs';

interface IProps {
  data: [IDocRowMycent[]];
  documentName: string;
  dateDenounce: Date | string;
}

function DynamicTableMycent(props: IProps) {
  const { data, documentName, dateDenounce } = props;
  const [adminDaysCol, setAdminDaysCol] = useState<number>(0);

  let dynamicColumns: any = [];
  let modifiedData: any[] = [];
  let dynamicData: any[] = [];

  const sortByDisplayNo = (itemA, itemB) =>
    parseInt(itemA.display_no, 10) - parseInt(itemB.display_no, 10);
  if (data[0].length) {
    // Генерация колонок (однажды, по первой строке)
    const filterData = [...data[0]].sort(sortByDisplayNo);
    for (let col = 0; col < filterData.length; col++) {
      dynamicColumns.push({
        title: filterData[col].field_name,
        key: `col-${col}`,
        dataIndex: `full_name_${col}`,
      });
    }

    // Генерация строк таблицы
    dynamicData = data.map((rowItems, rowIndex) => {
      const sortedRow = [...rowItems].sort(sortByDisplayNo);
      const rowData: any = { key: `row-${rowIndex}`, rowKey: rowIndex };

      for (let col = 0; col < sortedRow.length; col++) {
        const item = sortedRow[col];

        if (item.num_value?.full_name) {
          rowData[`full_name_${col}`] = item.num_value.full_name;
        } else if (
          Array.isArray(item.convertByJsonValues) &&
          item.convertByJsonValues.length
        ) {
          rowData[`full_name_${col}`] = item.convertByJsonValues.join(', ');
        } else if (item.date_value) {
          rowData[`full_name_${col}`] = item.date_value;
        } else {
          rowData[`full_name_${col}`] = '';
        }
      }

      return rowData;
    });
  }

  // if (data[0].length) {
  //   for (let row = 0; row < 1; row++) {
  //     const filterData = [...data[row]].sort(sortByDisplayNo);

  //     for (let col = 0; col < data[0].length; col++) {
  //       dynamicColumns.push({
  //         title: filterData[col].field_name,
  //         key: `row-${row}-col-${col}`,
  //         dataIndex: `full_name_${col}` ,
  //         rowKey: row,
  //       });
  //     }
  //   }

  //   for (let row = 0; row < data.length; row++) {
  //     const filterData = [...data[row]].sort(sortByDisplayNo);
  //     for (let col = 0; col < data[row].length; col++) {
  //       if (filterData[col].num_value?.full_name) {
  //         modifiedData.push({
  //           key: `row-${row}-col-${col}`,
  //           [`full_name_${col}`]: filterData[col].num_value?.full_name
  //             ? filterData[col].num_value?.full_name
  //             : filterData[col].num_value,
  //           rowKey: row,
  //         });
  //       } else if (filterData[col].date_value) {
  //         modifiedData.push({
  //           key: `row-${row}-col-${col}`,
  //           [`full_name_${col}`]: filterData[col].date_value,
  //           rowKey: row,
  //         });
  //       }
  //     }
  //   }
  // }

  // if (data[0].length) {
  //   for (let row = 0; row < data.length; row++) {
  //     dynamicData = Object.values(
  //       modifiedData.reduce((acc, curr) => {
  //         const { key, rowKey } = curr;
  //         if (!acc[rowKey]) {
  //           acc[rowKey] = { key: '', rowKey };
  //         }
  //         if (key.includes(`row-${rowKey}-col-`)) {
  //           const suffix = key.split('-').pop();
  //           acc[rowKey][`full_name_${suffix}`] = curr[`full_name_${suffix}`];
  //         }
  //         acc[rowKey].key = key;
  //         return acc;
  //       }, {})
  //     );
  //   }
  // }

  if (documentName === 'Заявление на административный день') {
    const user: any = data[0].find((item: any) => item.type === 'DEPTEMPL');

    const adminDaysFetch = async () => {
      const { data } = await api.getAdminDays({
        isn: user?.num_value?.foreign_id,
      });
      setAdminDaysCol(data);
    };

    adminDaysFetch();

    if (
      !dynamicColumns.find((item) => item.title === 'Доступное кол-во дней')
    ) {
      dynamicColumns.push({
        title: 'Доступное кол-во дней',
        key: 'row-0-col-6',
        dataIndex: 'full_name_6',
        rowKey: 0,
      });
      dynamicData[0].full_name_6 = `${adminDaysCol}`;
    }
  }

  if (documentName === 'СЗ. Соглашение о расторжении') {
    dynamicColumns.push({
      title: 'Доср. прекращ.',
      key: 'row-0-col-3',
      dataIndex: 'full_name_3',
      rowKey: 0,
    });
    [dynamicColumns[2], dynamicColumns[3]] = [
      dynamicColumns[3],
      dynamicColumns[2],
    ];
    dateDenounce
      ? (dynamicData[0].full_name_3 = dayjs(dateDenounce).format('DD.MM.YYYY'))
      : '';
  }

  return (
    <Table
      dataSource={dynamicData}
      columns={dynamicColumns}
      bordered
      scroll={{ x: 1000 }}
    />
  );
}

export default DynamicTableMycent;
